import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../../Layout";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import LabService from "../../Services/LabService";
import LocationService from "../../Services/LocationService";
import { Flex, message, Modal, Spin } from "antd";
import { convertUTCDate } from "../../utils/convertionFunc";
import nodatafound from "../../assets/images/Svg/nodatafound.svg";
import LabTestCard from "./labTestCard";
import { useSelector } from "react-redux";
import PatientService from "../../Services/PatientService";

function BookLabtest() {
  const { patientData } = useSelector((state) => state.auth);
  const { countries, states } = useSelector((state) => state.common);
  const [labTests, setLabTests] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [deliverable, setDeliverable] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [selected, setSelected] = useState();
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [selectedAddress, setSelectedAddress] = useState();
  const [showModal, setShowModal] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [availPinCode, setAvailPincode] = useState("");
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [addressLoader, setAddressLoader] = useState(false);
  const [addressModButton, setAddressModButton] = useState(false);
  const [patientMembershipDet, setPatientMembershipDet] = useState(null);

  const fetchMembershipDetails = async () => {
    const payload = {
      membershipCard: patientData?.membershipCard || "",
      serviceCode: "LAB",
    };

    try {
      const response = await PatientService.patientMembershipDet(payload);
      console.log("From Index", response.data);

      setPatientMembershipDet(response?.data?.data || null);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (patientData?.membershipCard) {
      fetchMembershipDetails();
    }
  }, [patientData]);

  const [formData, setFormData] = useState({
    address1: "",
    address2: "",
    city: "",
    country: "",
    mobile: "",
    pinCode: "",
    state: "",
  });

  useEffect(() => {
    fetchData("health");
  }, []);

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      getPatientAddresses();
      fetchPatientAddress();
      const pin = patientData.pinCode;
      if (pin) {
        setAvailPincode(pin);
        checkAvailability(pin);
      }
    }
  }, [patientData]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const fetchData = async (name) => {
    const payload = {
      testName: name,
      status: 1,
    };
    try {
      const response = await fetchLabTests(payload);
      setLabTests(response?.data?.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleClickOutside = (e) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target) &&
      inputRef.current !== e.target
    ) {
      setShowDropdown(false);
    }
  };

  const fetchLabTests = async (labName) => {
    setLoader(true);
    try {
      const response = await LabService.LabTestMdm(labName);
      setLoader(false);
      return response;
    } catch (e) {
      setLoader(false);
      console.error(e);
    }
  };

  const handleClick = () => {
    navigate(APP_ROUTES.LABTESTSALL);
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchVal(value);
    if (value.length > 2) {
      fetchData(value);
    } else if (value.length === 0) {
      fetchData("health");
    }
  };

  const handleSelectTest = (item) => {
    setLabTests([item]);
    setShowDropdown(false);
  };

  const getPatientAddresses = async () => {
    let payload = {
      patientId: patientData?.patientId,
      status: 1,
    };

    try {
      setLoading(true);
      let result = await LocationService.getPatientAddress(payload);
      if (result.data.length > 0) {
        setAddresses(result.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNewAddress = () => {
    setIsAddressModalOpen(true);
    setFormData((prevState) => ({
      ...prevState,
      firstName: patientData?.firstName,
      address1: patientData?.address1,
      address2: patientData?.address2,
      city: patientData?.city,
      country: patientData?.country,
      mobile: patientData?.mobile,
      pinCode: patientData?.pinCode,
      state: patientData?.state,
    }));
  };

  const checkServiceAvailability = async (pincode) => {
    if (!pincode || pincode.length !== 6) return;

    let payload = {
      pincode,
      status: 1,
    };

    try {
      let result = await LocationService.checkAvailability(payload);

      if (result.data.length > 0) {
        setDeliverable(pincode);
        setShowModal(false);
      } else {
        message.error(
          "Service is not available in this area, choose another area",
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddressSave = async (e) => {
    e.preventDefault();
    const isFormEmpty = Object.values(formData).every(
      (value) => value.trim() === "",
    );

    if (isFormEmpty) {
      message.error("Please enter values in the form");
      return;
    }

    let payload = {
      account_Id: patientData.account_Id,
      clinic_Id: patientData.clinic_Id,
      createdBy: patientData.patientId,
      modifiedBy: patientData.patientId,
      patientId: patientData.patientId,
      defaultAddressYN: "Y",
      status: 1,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      ...formData,
    };
    setAddressLoader(true);
    try {
      await LocationService.savePatientAddress(payload);
      setAddressModButton(false);
      setIsAddressModalOpen(false);
      checkServiceAvailability(formData.pinCode);
      setAvailPincode(formData.pinCode);
      fetchPatientAddress();
    } catch (error) {
      console.error(error);
      setAddressLoader(false);
    } finally {
      setAddressLoader(false);
    }
  };

  const handleAdrrsFormClose = () => {
    setIsAddressModalOpen(false);
    setFormData({
      firstName: "",
      address1: "",
      address2: "",
      city: "",
      country: "",
      mobile: "",
      pinCode: "",
      state: "",
    });
  };

  const handleSelectedAddress = (address, index) => {
    setSelectedAddress(address);
    setSelected(index);
    setAvailPincode(address?.pinCode);
  };

  const checkAvail = (e) => {
    const pincode = e.target.value;
    setAvailPincode(pincode);

    if (pincode.length === 6) {
      checkAvailability(pincode);
    }
  };

  const [address, setAddress] = useState(null);

  const fetchPatientAddress = async () => {
    let payload = {
      patientId: patientData.patientId,
      defaultAddressYN: "Y",
      status: 1,
    };

    try {
      setLoading(true);
      let result = await LocationService.getPatientAddress(payload);
      if (result.data.length > 0) {
        setAddress(result?.data?.[0] || null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const checkAvailability = async (pincode) => {
    if (!pincode || pincode.length !== 6) return;

    let payload = {
      pincode,
      status: 1,
    };

    try {
      let result = await LocationService.checkAvailability(payload);

      if (result.data.length > 0) {
        setDeliverable(pincode);

        if (selectedAddress?.pinCode === pincode) {
          let defaultPayload = {
            defaultAddressYN: "Y",
            id: selectedAddress.id,
            patientId: selectedAddress.patientId,
          };
          await LocationService.setDefaultAddress(defaultPayload);
        }

        setShowModal(false);
      } else {
        message.error(
          "Service is not available in this area, choose another area",
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layout>
      <div className="p-5 w-[90%] m-auto">
        <h3 className="text-[#232323] font-sans font-semibold text-xl mx-28 sm:mx-0">
          Book Lab Test
        </h3>
        <div className="flex sm:flex-col justify-center items-center mt-5">
          <div className="w-[15%]"></div>
          <div>
            <div className="flex sm:flex-col gap-3">
              <div className="flex items-center border rounded-md px-3 py-1">
                <MdLocationOn className="text-[#189FAA] text-lg mr-2" />
                <input
                  onChange={checkAvail}
                  value={availPinCode}
                  type="text"
                  placeholder="Enter Pincode"
                  className="text-sm font-sans font-medium outline-none placeholder:text-xs w-full mx-2"
                />
              </div>
              <div class="relative w-[480px] sm:w-full rounded-md border p-1">
                <input
                  onChange={handleSearch}
                  value={searchVal}
                  type="text"
                  className="w-full pl-8 pr-24 py-1 font-sans font-medium text-sm placeholder:text-xs text-gray-700 bg-transparent rounded-md focus:outline-none"
                  placeholder="Search Lab Tests, Health Check-up Packages"
                />
                <button
                  onClick={() => fetchData(searchVal)}
                  className="absolute right-1 top-1 bottom-1 px-6 bg-[#189FAA] text-white font-sans text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5044e4]"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
          {patientData && (
            <h3
              className="font-sans underline cursor-pointer  mx-2 font-semibold text-sm text-[#189FAA]"
              onClick={handleNewAddress}
            >
              Add address
            </h3>
          )}
        </div>
        <div className="mt-7 flex items-center gap-5 w-[80%] sm:w-full mx-auto">
          <div className="w-full border rounded-md p-3 mb-4 h-[500px] overflow-y-scroll scrollWidth">
            {loader && labTests?.length === 0 ? (
              <div className="h-[300px] flex items-center justify-center">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : !loader && labTests?.length === 0 ? (
              <div className="flex flex-col items-center justify-center">
                <img
                  src={nodatafound}
                  alt="nodatafound"
                  className="h-min w-min"
                />
                <p className="font-medium text-xl">No data found!!</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-5 w-full">
                {labTests.map((test, index) => (
                  <LabTestCard
                    address={address}
                    test={test}
                    deliverable={deliverable}
                    patientMembershipDet={patientMembershipDet}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
        <Modal
          title={
            <span className="text-sm font-semibold font-sans text-[#189FAA]">
              Add Address
            </span>
          }
          open={isAddressModalOpen}
          onCancel={handleAdrrsFormClose}
          footer={[]}
          destroyOnClose
        >
          <form className="space-y-4 mt-3">
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Name"
                name="firstName"
                disabled={true}
                value={formData.firstName || ""}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Mobile Number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Pin Code"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <select
                value={formData.state}
                onChange={handleChange}
                name="state"
                className="w-full py-2 px-3 border rounded text-xs text-gray-400 font-sans  outline-none"
              >
                <option value="" disabled>
                  Select State
                </option>
                {states.map((state) => (
                  <option key={state.stateId} value={state.stateId}>
                    {state.stateName}
                  </option>
                ))}
              </select>
              <select
                value={formData.country}
                onChange={handleChange}
                name="country"
                className="w-full px-3 py-2 border rounded font-sans text-gray-400  text-xs outline-none"
              >
                <option value="" disabled>
                  Select Country
                </option>
                {countries.map((country) => (
                  <option key={country.country_Id} value={country.country_Id}>
                    {country.country_Name}
                  </option>
                ))}
              </select>
            </div>
            <textarea
              placeholder="Full Address"
              rows="3"
              value={formData.address1}
              name="address1"
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
            />

            <div className="flex justify-end gap-4 mt-4">
              <button
                type="button"
                disabled={addressLoader}
                onClick={handleAdrrsFormClose}
                className="px-4 py-1 border border-cyan-600 font-sans text-sm font-medium text-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Cancel
              </button>
              <button
                disabled={addressLoader}
                className="px-4 py-1 bg-[#189FAA] font-sans text-sm text-white font-semibold rounded disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleAddressSave}
              >
                Save Address
              </button>
            </div>
          </form>
        </Modal>
        {/* <div className="h-[49px] w-full border rounded-md flex justify-between items-center p-5 mt-3">
          <p className="text-sm font-sans font-normal text-[#333333]">
            Showing 1 to 12 of 20
          </p>
          <div className="flex items-center justify-center space-x-2">
            <button className="p-2 rounded-md text-gray-700 bg-white">
              <FaChevronLeft className="text-[#189FAA]" />
            </button>

            <button className="px-3 py-1 rounded-md bg-teal-500 text-white text-sm">
              1
            </button>
            <button className="px-3 py-1 rounded-md text-gray-700 text-sm hover:bg-gray-200 bg-white border">
              2
            </button>
            <button className="px-3 py-1 rounded-md text-gray-700 text-sm hover:bg-gray-200 bg-white border">
              3
            </button>
            <button className="px-3 py-1 rounded-md text-gray-700 text-sm hover:bg-gray-200 bg-white border">
              4
            </button>

            <button className="p-2 rounded-md text-gray-700 bg-white">
              <FaChevronRight className="text-[#189FAA]" />
            </button>
          </div>
        </div> */}
      </div>
    </Layout>
  );
}

export default BookLabtest;
